import * as React from 'react';
import cx from 'classnames';
import ClickAwayListener from 'react-click-away-listener';

import './Actions.styles.scss';

export const Actions = (props) => {
	const { className, items = [], id, data, style, onClose } = props;

	const handleClick = React.useCallback((onClick) => (e) => {
		onClick({ id, e, data });
		onClose();
	}, [id, data]);

	return (
		<ClickAwayListener onClickAway={onClose}>
			<div
				style={style}
				className={cx('Actions', className)}
			>
				{items.map((item) => (
					<button className={cx('Actions__item', item.className)} key={item.label} onClick={handleClick(item.onClick)}>
						{item.label}
					</button>
				))}
			</div>
		</ClickAwayListener>
	);
}